/**
 * EN dictionary — keyed by the original French string (which acts as a
 * stable, readable key). Only public-facing pages V1.
 *
 * Missing entries fall back to French (handled by t()).
 */
export const EN = {
  // ----- Header / navigation -----
  'Accueil': 'Home',
  'Tarifs': 'Pricing',
  'Ressources': 'Resources',
  'À propos': 'About',
  'Entraînement': 'Training',
  'Mini-jeux': 'Training', // legacy key — kept in case translations still use it
  'Dictionnaire': 'Dictionary',
  'Connexion': 'Sign in',
  'Mon espace': 'My account',
  'Réserver un cours': 'Book a lesson',
  'Déconnexion': 'Sign out',
  'Anthony Savarit': 'Anthony Savarit',
  'Leçons privées à domicile': 'Private home lessons',

  // ----- Home — Hero -----
  'Leçons privées à domicile · Genève': 'Private home lessons · Geneva',
  "L'art de la guitare,": 'The art of the guitar,',
  'à votre rythme.': 'at your own pace.',
  "Cours particuliers de guitare à domicile à Genève — pour adultes, adolescents et enfants motivés. Débutant ou confirmé, je construis avec vous un parcours sur mesure, exigeant et inspirant.":
    'Private home guitar lessons in Geneva — for motivated adults, teens and children. Beginner or experienced, I build a tailored, demanding and inspiring journey with you.',
  'Adultes débutants bienvenus.': 'Adult beginners welcome.',
  'Commencer la guitare': 'Start playing guitar',
  'Réponse sous 24 h': 'Reply within 24h',
  'Cours à domicile · Genève': 'Home lessons · Geneva',
  'Suivi personnalisé': 'Personal coaching',
  'Quelques créneaux disponibles': 'A few openings available',

  // ----- Home — Sections -----
  'MA MÉTHODE': 'MY METHOD',
  'Une approche claire, exigeante et progressive': 'A clear, demanding and progressive approach',
  "Comprendre simplement. Jouer sérieusement.": 'Understand simply. Play seriously.',
  'Progression': 'Progression',
  'Vos premiers résultats': 'Your first results',
  'Une progression jalonnée, du premier accord à votre répertoire personnel.':
    'A milestoned journey, from the first chord to your personal repertoire.',
  'Vos premiers accords': 'Your first chords',
  "Les bases solides : posture, premiers accords ouverts, rythmiques simples. Vous jouez déjà vos premières mélodies.":
    'Solid foundations: posture, first open chords, simple rhythms. You are already playing your first melodies.',
  'Votre première chanson': 'Your first song',
  "Enchaînements fluides, lecture rythmique, vocabulaire enrichi. Vous interprétez votre première chanson de bout en bout.":
    'Smooth transitions, rhythmic reading, expanded vocabulary. You play your first song from start to finish.',
  'Un répertoire personnel': 'A personal repertoire',
  "Style affirmé, autonomie sur de nouveaux morceaux, premières improvisations. Vous construisez un répertoire qui vous ressemble.":
    'Confident style, autonomy on new pieces, first improvisations. You build a repertoire that reflects who you are.',
  'Après 1 mois': 'After 1 month',
  'Après 3 mois': 'After 3 months',
  'Après 6 mois': 'After 6 months',

  // ----- Philosophy -----
  'Philosophie': 'Philosophy',
  'Apprendre avec plaisir': 'Learn with joy',
  "Chaque élève entretient un lien unique avec la musique. Mon rôle est de vous guider avec méthode, écoute et exigence, afin de construire un parcours qui vous ressemble.":
    'Every student has a unique relationship with music. My role is to guide you with method, attentive listening and high standards, so we build a journey that reflects who you are.',
  "Plus de 10 ans d'expérience": '10+ years of experience',
  'Classique, acoustique, électrique': 'Classical, acoustic, electric',
  'Enfants dès 5 ans et adultes': 'Children from age 5 and adults',
  'Accessible à tous niveaux': 'Open to all levels',

  // ----- Pricing teaser on Home -----
  'Formules simples': 'Simple plans',
  'Cours individuels, collectifs et packs avantageux': 'Individual lessons, group classes and value packs',
  'Le plus populaire': 'Most popular',
  'Réserver maintenant': 'Book now',
  'Voir tous les tarifs': 'See all pricing',

  // ----- Final CTA -----
  'Commençons ensemble': "Let's start together",
  'Réservez votre première leçon à domicile.': 'Book your first home lesson.',
  'Sans engagement, simplement le plaisir de commencer.':
    'No commitment — just the joy of getting started.',
  'Prendre rendez-vous': 'Book an appointment',

  // ----- Disponibilité notice -----
  'Disponibilité': 'Availability',
  "La plupart des créneaux après l'école sont rapidement réservés.":
    'Most after-school slots fill up quickly.',
  "N'hésitez pas à consulter les disponibilités directement en ligne.":
    "Feel free to check current openings directly online.",

  // ----- Philosophy duplicates removed; see Sections block above -----

  // ----- CTA finals / shared -----
  'Voir les tarifs': 'See pricing',
  'Découvrir la méthode': 'Discover the method',
  'En savoir plus': 'Learn more',
  'Prêt à commencer ?': 'Ready to start?',

  // ----- Pricing page -----
  'Formules & tarifs': 'Plans & pricing',
  "Trois formats pensés pour s'adapter à votre rythme — du premier essai à la progression accélérée. Tous les cours sont privés et donnés à votre domicile à Genève.":
    "Three formats designed to fit your pace — from a first try to accelerated progress. All lessons are private and held at your home in Geneva.",
  'Cours individuels': 'Individual lessons',
  'Un enseignement entièrement dédié à votre progression, structuré autour de vos objectifs musicaux.':
    'Teaching entirely focused on your progress, built around your musical goals.',
  'Séance Découverte': 'Discovery Session',
  'Format Recommandé': 'Recommended Format',
  'Séance Premium': 'Premium Session',
  '30 minutes': '30 minutes',
  '45 minutes': '45 minutes',
  '1 heure': '1 hour',
  'À domicile à Genève': 'At your home in Geneva',
  'Idéale pour débuter ou tester': 'Perfect to start or try out',
  'Sans engagement': 'No commitment',
  'Le meilleur rapport temps / progression': 'The best time / progress balance',
  'Format préféré des élèves': 'Students\' favourite format',
  'Apprentissage approfondi': 'In-depth learning',
  'Progression accélérée': 'Accelerated progress',
  'leçon': 'lesson',
  'Réserver': 'Book',
  'Cours collectifs': 'Group lessons',
  'Apprenez ensemble, progressez en groupe': 'Learn together, grow as a group',
  'personne / heure': 'person / hour',
  'Maximum 3 élèves': 'Up to 3 students',
  'Durée : 1 heure': 'Duration: 1 hour',
  'À domicile': 'At your home',
  'Dynamique de groupe': 'Group dynamic',
  'Tarif avantageux': 'Great value',
  'Réserver un cours collectif': 'Book a group lesson',
  'Idéal pour': 'Ideal for',
  'Familles et amis': 'Families and friends',
  'Apprentissage convivial': 'Friendly learning',
  'Budget maîtrisé': 'Controlled budget',
  'Motivation collective': 'Group motivation',
  'Packs avantageux': 'Value packs',
  "Cours d'1 heure en formule groupée pour un meilleur suivi": 'One-hour lessons bundled for better follow-up',
  'Pack 5 leçons': '5-lesson Pack',
  'Pack 10 leçons': '10-lesson Pack',
  '5 × 1 heure': '5 × 1 hour',
  '10 × 1 heure': '10 × 1 hour',
  'Économie de 25 CHF': 'Save 25 CHF',
  'Économie de 100 CHF': 'Save 100 CHF',
  'Suivi personnalisé': 'Personal coaching',
  'Priorité planning': 'Schedule priority',
  'Programme structuré': 'Structured programme',
  'Ressource exclusive': 'Exclusive resource',
  'Choisir ce pack': 'Choose this pack',
  'Une question sur les tarifs ?': 'A question about pricing?',
  "N'hésitez pas à me contacter pour discuter de la formule la mieux adaptée à vos besoins.":
    'Feel free to reach out and discuss the plan best suited to your needs.',
  'Me contacter': 'Get in touch',

  // ----- Home — Méthode -----
  'Ma méthode': 'My method',
  'Un apprentissage moderne, structuré et motivant.': 'A modern, structured and motivating approach to learning.',
  'Cours privés à domicile': 'Private home lessons',
  "Des cours adaptés au niveau, au rythme et aux objectifs de chaque élève.": "Lessons tailored to each student's level, pace and goals.",
  "Conseils, ressources et accompagnement entre les séances.": 'Guidance, resources and support between sessions.',
  'Espace élève privé': 'Private student space',
  "Planning, progression, partitions, enregistrements et contenus accessibles en ligne.": 'Schedule, progress, scores, recordings and content available online.',
  'Entraînement interactif': 'Interactive training',
  'Mini-jeux interactifs': 'Interactive training',
  "Apprendre les accords, le rythme et la théorie de manière ludique.": 'Learn chords, rhythm and theory through play.',
  'Progression claire': 'Clear progression',
  "Un parcours évolutif avec objectifs concrets et motivation constante.": 'A progressive path with concrete goals and constant motivation.',
  'Réserver un premier cours': 'Book a first lesson',
  'Essayer l\'entraînement': 'Try the training',
  'Essayer un mini-jeu': 'Try the training',

  // ----- Home — Pricing cards -----
  "Cours à l'unité": 'Single lesson',
  'Programme dix cours': 'Ten-lesson programme',
  '1 heure': '1 hour',
  '5 heures': '5 hours',
  '10 heures': '10 hours',
  'À domicile': 'At your home',
  'Évaluation du niveau': 'Level assessment',
  'Conseil personnalisé': 'Personal advice',
  'Sans engagement': 'No commitment',

  // ----- Booking page (form details) -----
  'Réservation': 'Booking',
  'Réservez votre cours': 'Book your lesson',
  'Date & Heure': 'Date & Time',
  'Informations': 'Information',
  'Paiement': 'Payment',
  'Choisissez votre créneau': 'Choose your time slot',
  'Horaires disponibles': 'Available times',
  'Choisir une date': 'Choose a date',
  'Choisir un créneau': 'Choose a time slot',
  'Type de cours': 'Lesson type',
  'Cours hebdomadaire récurrent': 'Weekly recurring lesson',
  'Confirmer la réservation': 'Confirm booking',
  'Vos informations': 'Your details',
  'Nom complet': 'Full name',
  'Prénom': 'First name',
  'Nom': 'Last name',
  'Email': 'Email',
  'Téléphone': 'Phone',
  'Adresse du cours': 'Lesson address',
  'Formule': 'Plan',
  'Découverte - 80€': 'Discovery — €80',
  'Régulier (5 cours) - 360€': 'Regular (5 lessons) — €360',
  'Intensif (10 cours) - 680€': 'Intensive (10 lessons) — €680',
  'Message (optionnel)': 'Message (optional)',
  'Aucun créneau disponible': 'No openings available',
  'Aucun créneau disponible ce jour': 'No openings on this day',
  'Veuillez choisir une autre date': 'Please choose another date',
  'Cours à domicile uniquement à Genève': 'Home lessons in Geneva only',
  'Continuer': 'Continue',
  'Retour': 'Back',
  'Récapitulatif': 'Summary',
  'Mode démo :': 'Demo mode:',
  'Le paiement Stripe réel sera intégré prochainement.': 'Real Stripe payment will be integrated soon.',
  'Numéro de carte': 'Card number',
  'Expiration': 'Expiration',
  'Traitement...': 'Processing…',
  'Payer': 'Pay',
  'Date': 'Date',
  'Heure': 'Time',
  'Lieu': 'Location',
  'Total': 'Total',
  "Annulation gratuite jusqu'à 24h avant le cours": 'Free cancellation up to 24h before the lesson',
  'Réservation confirmée': 'Booking confirmed',
  'Votre cours a été réservé. Vous recevrez un email de confirmation.': 'Your lesson is booked. You will receive a confirmation email.',
  'Voir mon espace': 'Go to my account',

  // ----- About page -----
  'Anthony Savarit · Guitariste & Professeur': 'Anthony Savarit · Guitarist & Teacher',
  'Je suis guitariste et professeur basé à Genève.': "I'm a guitarist and teacher based in Geneva.",
  "J'accompagne des élèves de tous niveaux avec une approche simple, structurée et progressive, en mettant l'accent sur la compréhension et le plaisir de jouer.":
    'I work with students of all levels using a simple, structured and progressive approach, with a focus on understanding and the joy of playing.',
  'Parcours musical': 'Musical journey',
  "La scène et l'enseignement, ensemble": 'Stage and teaching, together',
  "En parallèle de l'enseignement, je développe un projet artistique personnel et collabore avec différents musiciens.":
    "Alongside teaching, I'm developing a personal artistic project and collaborating with various musicians.",
  "J'ai participé à plusieurs enregistrements et projets, et je suis régulièrement amené à jouer en live, en Suisse et à l'étranger.":
    "I've taken part in several recordings and projects, and I regularly perform live, in Switzerland and abroad.",
  "Ces expériences nourrissent directement mon enseignement, en apportant une approche concrète et musicale du jeu.":
    "These experiences feed directly into my teaching, bringing a hands-on, musical approach to playing.",
  "Vous pouvez écouter certains morceaux auxquels j'ai contribué ici :":
    "You can listen to some of the tracks I've contributed to here:",
  'Extrait live': 'Live excerpt',
  'Approche pédagogique': 'Teaching approach',
  'Comprendre simplement, approfondir ensuite': 'Understand simply, then go deeper',
  "Avec l'expérience, j'ai constaté que beaucoup d'élèves se retrouvent bloqués non pas par manque de capacité, mais par des explications trop complexes ou mal adaptées.":
    "Through experience, I've noticed that many students get stuck not for lack of ability, but because of overly complex or poorly adapted explanations.",
  "C'est pour cette raison que j'ai développé une méthode basée sur deux principes :":
    "That's why I've developed a method built on two principles:",
  'Comprendre simplement': 'Understand simply',
  'Approfondir ensuite': 'Then go deeper',
  "Chaque notion est d'abord abordée de manière claire et intuitive, avant d'être développée plus en profondeur.":
    'Each concept is first introduced in a clear, intuitive way before being developed in greater depth.',
  "L'objectif est d'éviter la confusion et de construire des bases solides sur le long terme.":
    'The goal is to avoid confusion and build solid long-term foundations.',
  'Les cours': 'The lessons',
  'Privés, à domicile, à votre rythme': 'Private, at home, at your own pace',
  'Les cours se déroulent à domicile dans la région de Genève.':
    'Lessons take place at home in the Geneva area.',
  'Ils sont adaptés au niveau, aux objectifs et au rythme de chaque élève.':
    'They are adapted to each student\'s level, goals and pace.',
  "Que ce soit pour débuter, reprendre ou progresser, l'idée reste la même : avancer de manière claire, efficace et sans stress.":
    "Whether you're starting out, picking up again or progressing, the idea is the same: move forward clearly, effectively and stress-free.",
  'Contact': 'Contact',
  'Réservez ou écrivez-moi': 'Book or get in touch',
  "Pour toute demande ou pour réserver un cours, vous pouvez utiliser le système de réservation en ligne ou me contacter directement.":
    "For any question or to book a lesson, you can use the online booking system or contact me directly.",
  'Note': 'Note',
  'Un projet musical personnel': 'A personal music project',
  'Je développe également un projet musical personnel.': "I'm also working on a personal music project.",
  "Si vous souhaitez en savoir plus ou suivre son évolution, vous pouvez me contacter.":
    "If you'd like to know more or follow its progress, feel free to reach out.",
};
